import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

export default class extends Controller {
  static values = { url: String };
  static targets = ["emailCount", "phoneCount"];

  async connect() {
    const response = await get(this.urlValue, { responseKind: "json" });
    if (response.ok) {
      const data = await response.json;
      this.emailCountTarget.textContent = `${data.email_opted_out_count} opted out`;
      this.phoneCountTarget.textContent = `${data.phone_opted_out_count} opted out`;
    }
  }
}
